import React, { Suspense } from 'react';
import { Facebook as LoadingState } from 'react-content-loader';
import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Icon from 'components/icons/Icon';
import { useHistory } from 'react-router-dom';

interface AgentsDetailHeadProps {
  agents: any;
  statusFilter: string;
  getFilterColor: (filter: string) => string;
}

const AgentTable: React.FC<AgentsDetailHeadProps> = props => {
  const { agents, statusFilter, getFilterColor } = props;
  const { t } = useTranslation(['super_admin_agent']);
  const history = useHistory();

  const go = (id: number) => {
    history.replace(`/agents/updateAgent/${id}`);
  };

  return (
    <Suspense fallback={<LoadingState height="230px" width="100%" />}>
      <TableContainer component={Paper} className="table_container">
        <Table
          sx={{ minWidth: 750 }}
          size="medium"
          aria-label="a dense table"
          className="table"
        >
          <TableHead>
            <TableRow>
              <TableCell align="center" className="column">
                {t('super_admin_agent:id')}
              </TableCell>
              <TableCell align="center" className="column">
                {t('super_admin_agent:name')}
              </TableCell>
              <TableCell align="center" className="column">
                {t('super_admin_agent:lastName')}
              </TableCell>
              <TableCell align="center" className="column">
                {t('super_admin_agent:email')}
              </TableCell>
              <TableCell align="center" className="column">
                {t('super_admin_agent:company')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agents?.map((agent: any) => {
              return (
                <TableRow
                  key={agent.id}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 }
                  }}
                  className="column-body"
                >
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    style={
                      statusFilter === 'id'
                        ? { color: getFilterColor('id'), fontWeight: 'bold' }
                        : {}
                    }
                  >
                    {agent.id}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    style={
                      statusFilter === 'name'
                        ? { color: getFilterColor('name'), fontWeight: 'bold' }
                        : {}
                    }
                  >
                    {agent.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    style={
                      statusFilter === 'name'
                        ? { color: getFilterColor('name'), fontWeight: 'bold' }
                        : {}
                    }
                  >
                    {agent.lastName}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {agent.email}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    style={
                      statusFilter === 'company'
                        ? {
                            color: getFilterColor('company'),
                            fontWeight: 'bold'
                          }
                        : {}
                    }
                  >
                    {agent.companies
                      ?.map(
                        (company: { id: number; name: string }) => company.name
                      )
                      .join(', ')}
                  </TableCell>
                  <TableCell align="center">
                    <Icon
                      name="edit"
                      size="small"
                      onClick={() => go(agent.id)}
                      className="pointer"
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Suspense>
  );
};

export default AgentTable;
